import { ActionBase } from '../../../core/store/action/ActionBase';

export const FINALIZE_DYNAMICDATASET = '[DynamicDataSet] Finalize';

export class FinalizeDynamicDataSetAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = FINALIZE_DYNAMICDATASET;

  constructor(public payload: { dynamicDataSetKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/FinalizeDynamicDataSetAction.ts